import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function FormUnixDateField({
  label,
  name,
  placeholder,
  value,
  errorText,
  validationText,
  helpText,
  onChange,
  maxWidth,
  disabled = false,
}) {
  let dt = null;
  if (value === undefined || value === null || value === "") {
    // Do nothing...
  } else {
    dt = new Date(value * 1000);
  }

  let classNameText = "input";
  if (errorText) {
    classNameText = "input is-danger";
  }

  // Override the `onChange` function to convert the `date` to `timestamp`.
  const onUnixDateChange = (date) => {
    const ts = date.getTime() / 1000; // Convert `date` to `unix epoch timestamp`.
    onChange(ts);
  };

  return (
    <div class="field pb-4">
      <label class="label">{label}</label>
      <div class="control" style={{ maxWidth: maxWidth }}>
        <DatePicker
          className={classNameText}
          selected={dt}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
          onChange={(date) => onUnixDateChange(date)}
          minDate={new Date()}
        >
          <div style={{ color: "red" }}>{errorText}</div>
        </DatePicker>
      </div>
      {errorText && <p class="help is-danger">{errorText}</p>}
      {helpText && <p class="help">{helpText}</p>}
    </div>
  );
}

export default FormUnixDateField;
